import { render, staticRenderFns } from "./SidebarDibaCelina.vue?vue&type=template&id=2f20b8b2&scoped=true"
import script from "./SidebarDibaCelina.vue?vue&type=script&lang=js"
export * from "./SidebarDibaCelina.vue?vue&type=script&lang=js"
import style0 from "./SidebarDibaCelina.vue?vue&type=style&index=0&id=2f20b8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f20b8b2",
  null
  
)

export default component.exports